/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReplyListContainer3_story = {
    readonly id: string;
    readonly isClosed: boolean;
    readonly closedAt: string | null;
    readonly settings: {
        readonly live: {
            readonly enabled: boolean;
        };
    };
    readonly " $fragmentRefs": FragmentRefs<"ReplyListCommentContainer_story" | "ReplyListContainer4_story">;
    readonly " $refType": "ReplyListContainer3_story";
};
export type ReplyListContainer3_story$data = ReplyListContainer3_story;
export type ReplyListContainer3_story$key = {
    readonly " $data"?: ReplyListContainer3_story$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainer3_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReplyListContainer3_story",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isClosed",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "closedAt",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "StorySettings",
            "kind": "LinkedField",
            "name": "settings",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "LiveConfiguration",
                    "kind": "LinkedField",
                    "name": "live",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "enabled",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListCommentContainer_story"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListContainer4_story"
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = '072e095649df35f80b7b68f22b0b36e6';
export default node;
